import { render } from "./ElementVideo.vue?vue&type=template&id=9a415b7c&scoped=true"
import script from "./ElementVideo.vue?vue&type=script&lang=js"
export * from "./ElementVideo.vue?vue&type=script&lang=js"

import "./ElementVideo.vue?vue&type=style&index=0&id=9a415b7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a415b7c"]])

export default __exports__